'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

/**
 * Localizes a number into a number with a percent symbol.
 * Some locales place the number in front of the number,
 * after the number,
 * or after the number with a space in between.
 * @param locale string
 * @param value number
 * @returns string
 */ const localizePercentage = (locale, value)=>{
    const numberFormat = Intl.NumberFormat(locale, {
        style: 'percent',
        maximumFractionDigits: 2
    });
    return numberFormat.format(value / 100);
};

exports.localizePercentage = localizePercentage;
//# sourceMappingURL=percentage.js.map
